import reducer from './reducers';

import * as verificationOperations from './operations';

export { verificationOperations };

export default reducer;
